import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

export default () => {
  return [
    {
      path: 'fsm-cookie',
      name: ROUTES.FSM_COOKIE,
      component: () => dynamicImport(import('./FsmCookie.vue')),
    },
  ]
}
